<template>
    <div class="as-h2h-statistics">
        <div class="as-h2h-statistics__head">
            <IconH2HStatistics />
            <span> Thống kê đối đầu </span>
        </div>
        <div class="as-h2h-statistics__body">
            <FootballTeamItem :footyStats="footyStats" :match="match" modifyClass="as-vertical" mode="h2h" :showName="false" :showOnlyName="true" :showStatus="false" :showResult="false"/>
            <div class="as-vs">
                <div class="as-vs__tile">
                    <span>{{ footyStats?.h2h?.previous_matches_results?.totalMatches }}</span>
                    <span>Trận đấu</span>
                </div>
                <div class="as-vs__line">
                    <div class="as-vs-line-item">
                        <div class="as-vs-line-item__win" :style="{
                            width: `${ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0) }%`
                        }">
                            <!-- {{ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0) }}% -->
                        </div>
                        <div class="as-vs-line-item__draw" :style="{
                            width: `${ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 2) }%`
                        }">
                            <!-- {{ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 2) }}% -->
                        </div>
                        <div class="as-vs-line-item__loss" :style="{
                            width: `${ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 3) }%`
                            }">
                        <!-- {{ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 3) }}% -->
                        </div>
                    </div>
                </div>
            </div>
            <FootballTeamItem :footyStats="footyStats" :match="match" modeTeam="as-away" modifyClass="as-vertical" mode="h2h" :showName="false" :showOnlyName="true" :showStatus="false" :showResult="false"/>
        </div>
        <div class="as-result">
            <div class="as-result-body">
                <div class="as-result-item as-result-item__win">
                    <span>
                        {{ footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0 }} Thắng
                    </span>
                    <span>
                        ({{ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0) }}%)
                    </span>
                </div>
                <div class="as-result-item as-result-item__draw">
                    <span>
                        {{ footyStats?.h2h?.previous_matches_results?.draw ?? 0 }} Hoà
                    </span>
                    <span>
                        ({{ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 2) }}%)
                    </span>
                </div>
                <div class="as-result-item as-result-item__loss">
                    <span>
                        {{ footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0 }} Thắng
                    </span>
                    <span>
                        ({{ calculatorAVG(footyStats?.h2h?.previous_matches_results?.team_a_wins ?? 0, footyStats?.h2h?.previous_matches_results?.draw ?? 0, footyStats?.h2h?.previous_matches_results?.team_b_wins ?? 0, 3) }}%)
                    </span>
                </div>
            </div>
        </div>
        <div class="as-statics-list">
            <StaticsItem title="Trên 1.5" :mainValue="getValue('over_15')" :subTitle="getValue('sub_over_15', true)" classModify="as-green"/>
            <StaticsItem title="Trên 2.5" :mainValue="getValue('over_25')" :subTitle="getValue('sub_over_25', true)" classModify="as-green"/>
            <StaticsItem title="Trên 3.5" :mainValue="getValue('over_35')" :subTitle="getValue('sub_over_35', true)" classModify="as-L"/>
            <StaticsItem title="BTTS" :mainValue="getValue('btts')" :subTitle="getValue('sub_btts', true)"/>
            <StaticsItem title="Giữ sạch lưới" :subTitle="footyStats?.home_name" :mainValue="footyStats?.h2h.betting_stats.clubACSPercentage || 0" />
            <StaticsItem title="Giữ sạch lưới" :subTitle="footyStats?.away_name" :mainValue="footyStats?.h2h.betting_stats.clubBCSPercentage || 0" classModify="as-L"/>
        </div>
        <div class="as-previous-results">
            <div class="as-previous-results__head">
                <h4>
                    Kết quả trước đó
                </h4>
            </div>
            <div class="as-previous-results__body" v-if="previous_matches">
                <div class="as-previous-result-item" v-for="match in previous_matches">
                    <div class="as-previous-result-item__date">
                        <div>
                            {{ formatLocalTime(match.date_unix) }}
                        </div>
                    </div>
                    <div class="as-previous-result-item__info">
                        <div class="as-item-info">
                            <div class="as-home">
                                <PlayerItem :name="match?.team_a?.full_name || ''" :img="match?.team_a?.image || ''"  />
                            </div>
                            <div class="as-score">
                                <div class="as-scoreboard">
                                    <span class="as-match-item__vs as-t_vs_num">
                                        <span class="as-home-score" :class="{
                                            'as-winner': match.team_a_goals > match.team_b_goals
                                        }">{{ match.team_a_goals }}</span>
                                        :
                                        <span class="as-away-score" :class="{
                                            'as-winner': match.team_a_goals < match.team_b_goals
                                        }">{{ match.team_b_goals }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="as-away">
                                <PlayerItem :name="match?.team_b?.full_name || ''" :img="match?.team_b?.image || ''"  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconH2HStatistics from '~src/components/icons/foot_stats/IconH2HStatistics.vue';
    import FootballTeamItem from '../FootballTeamItem.vue';
    import type { IMatch } from '~src/interfaces';
    import StaticsItem from '../final_score/StaticsItem.vue';
    import type { IFootyStats, IPreviousMatchId, ITeam } from '~src/interfaces/footystats';
    import { formatLocalTime } from "~src/helpers/CommonHelper";
    import { onMounted, ref } from 'vue';
    import PlayerItem from './PlayerItem.vue';

    interface Props{
        match: IMatch;
        footyStats: IFootyStats | null
    }
    const props = withDefaults(defineProps<Props>(),{
    })
    const getValue = (mode = '', is_string = false) => {
        let _number = 0;
        let _string = '';
        const __h2h = props.footyStats?.h2h

        if(!__h2h){
            return is_string ? _string : _number;
        }
        const __total = __h2h.previous_matches_results.totalMatches;
        switch(mode){
            case 'over_15':
                _number = __h2h.betting_stats.over15Percentage
                break;
            case 'over_25':
                _number = __h2h.betting_stats.over25Percentage
                break;
            case 'over_35':
                _number = __h2h.betting_stats.over35Percentage
                break;
            case 'btts':
                _number = __h2h.betting_stats.bttsPercentage
                break;

            case 'sub_over_15':
                _string  = `${__h2h.betting_stats.over15}/${__total} trận`
                break;
            case 'sub_over_25':
                _string  = `${__h2h.betting_stats.over25}/${__total} trận`
                break;
            case 'sub_over_35':
                _string  = `${__h2h.betting_stats.over35}/${__total} trận`
                break;
            case 'sub_btts':
                _string  = `${__h2h.betting_stats.btts}/${__total} trận`
                break;
        }

        return is_string ? _string : _number;
    }
    const previous_matches = ref<IPreviousMatchId[]>(props?.footyStats?.h2h?.previous_matches_ids || [])
    onMounted(async () => {
        if (props?.footyStats?.h2h?.previous_matches_ids) {
            const previous_matches_ids = props?.footyStats?.h2h?.previous_matches_ids;
            const teams = props?.footyStats?.list_teams ?? [];

            previous_matches.value = previous_matches_ids.map((prev: IPreviousMatchId) => {
                let team_a = teams.find((p: ITeam) => p.id === prev.team_a_id);
                let team_b = teams.find((p: ITeam) => p.id === prev.team_b_id);
                return {
                    ...prev,
                    team_a,
                    team_b
                };
            });
        }
    });

    const calculatorAVG = (num_1: number, num_2: number, num_3: number, mode: number = 1) => {
        const _total = (num_1 + num_2 + num_3)
        let _number = num_1;
        if(mode == 2){
            _number = num_2;
        }else if(mode == 3){
            _number = num_3
        }

        if(_total > 0){
            return Math.round((_number / _total) * 100)
        }

        return 0;
    }
</script>

<script lang="ts">
export default {};
</script>
